
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import Fooduserwalletorders from './Fooduserwalletorders';
import './fooduserorders.css';
import {
    getAllOrders,
    getOrderById,

} from "../../../Servicefile/ordermanagementservice.jsx";
import {
    refundApi,
    refundDataProcessor,
    refundDateFormatter,
    refundExport,
    refundUIConstants,

} from '../../../Servicefile/Apiservice.js';
import OrderDetails from './OrderDetails.jsx';  // or './OrderDetails' based on your path
import { FaEye } from 'react-icons/fa';
// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Refund: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9" />
        </svg>
    ),
    Star: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
    ),
    StarEmpty: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
    ),
    Previous: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
        </svg>
    ),
    Next: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',

        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '130px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '150px'
    },
    dateInput: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '140px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflowX: 'auto',     // Show horizontal scrollbar
        overflowY: 'hidden',   // Hide vertical scrollbar
        whiteSpace: 'nowrap',  // Prevent columns from wrapping
        scrollbarWidth: 'thin', // Firefox
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 20
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusCompleted: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusCancelled: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        padding: '16px 0 0 0',
        flexWrap: 'wrap'
    },
    pageButton: {
        padding: '6px 14px',
        borderRadius: '6px',
        border: '1px solid #e2e8f0',
        background: 'white',
        color: '#4a5568',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontSize: '13px',
        fontWeight: '500',
        minWidth: '36px'
    },
    pageButtonActive: {
        background: 'rgb(230 109 51)',
        color: 'white',
        borderColor: 'rgb(230 109 51)'
    },
    pageButtonDisabled: {
        opacity: 0.5,
        cursor: 'not-allowed'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    refundButton: {
        padding: '4px 14px',
        borderRadius: '6px',
        border: 'none',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        minWidth: '70px',
        whiteSpace: 'nowrap'
    },
    refundActive: {
        background: '#FFC107',
        color: '#000'
    },
    refundDisabled: {
        background: '#48bb78',
        color: 'white',
        cursor: 'default'
    }
};

const Fooduserorders = () => {
    const [allOrders, setAllOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [displayedOrders, setDisplayedOrders] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [selectedDate, setSelectedDate] = useState("");
    const [page, setPage] = useState(0);
    const [viewType, setViewType] = useState("orders");
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [searchType, setSearchType] = useState("orderId");
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [showRefundPopup, setShowRefundPopup] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [refundStatus, setRefundStatus] = useState({});
    const { showLoader, hideLoader } = useLoader();
    const pageSize = 10;
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRefund, setSelectedRefund] = useState(null);
    const [refundHistory, setRefundHistory] = useState({});
    const searchOptions = [
        { value: "orderId", label: "Order ID" },
        // { value: "vendorId", label: "Vendor ID" },
        // { value: "name", label: "Name" },
        // { value: "companyName", label: "Company Name" },
        // { value: "category", label: "Category" }
    ];
    const [selectedOrderForView, setSelectedOrderForView] = useState(null);
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const handleViewOrder = (order) => {
        navigate(`/admin/orders/details/${order.orderId}`);
    };
    const [orderNotFound, setOrderNotFound] = useState(false);
    // Add this state
    // Add this state
    const [isSearching, setIsSearching] = useState(false);
    const [searchedOrder, setSearchedOrder] = useState(null);
    const getPlaceholderText = () => {
        switch (searchType) {
            case "orderId": return "Search by Order ID...";
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Name...";
            case "companyName": return "Search by Company...";
            case "category": return "Search by Category...";
            default: return "Search...";
        }
    };
    const closePopup = () => {
        setIsPopupOpen(false);
        setSelectedRefund(null);
    };

    // New function to handle order ID search via API
    // New function to handle order ID search via API
    const handleOrderIdSearch = async (orderId) => {
        if (!orderId.trim()) {
            // If search is empty, show all orders
            setFilteredOrders(allOrders);
            setDisplayedOrders(allOrders);
            setIsSearching(false);
            setSearchedOrder(null);
            return;
        }

        setIsSearching(true);
        showLoader();

        try {
            const token = localStorage.getItem("authToken");
            const order = await getOrderById(orderId, token);

            if (order) {
                setSearchedOrder(order);
                setFilteredOrders([order]);
                setDisplayedOrders([order]);
                setOrderNotFound(false);
            } else {
                setSearchedOrder(null);
                setFilteredOrders([]);
                setDisplayedOrders([]);
                setOrderNotFound(true);
            }
        } catch (error) {
            console.error("Error searching order:", error);
            // If order not found, show empty state
            setSearchedOrder(null);
            setFilteredOrders([]);
            setDisplayedOrders([]);
            // Optionally show a toast/notification
            // alert("Order not found");
        } finally {
            setIsSearching(false);
            hideLoader();
        }
    };

    // Modified search handler
    const handleSearch = (term) => {
        setSearchTerm(term);

        // If search type is orderId and term is not empty
        if (searchType === "orderId" && term.trim()) {
            // Debounce the search to avoid too many API calls
            clearTimeout(window.searchTimeout);
            window.searchTimeout = setTimeout(() => {
                handleOrderIdSearch(term);
            }, 500);
        } else if (!term.trim() && searchType === "orderId") {
            // If search is cleared, reset to show all orders
            setFilteredOrders(allOrders);
            setDisplayedOrders(allOrders);
        }
    };


    const fetchRefundHistory = async () => {
        try {
            const data = await refundApi.getAllRefundHistory();

            const refundMap = {};

            data.forEach(item => {
                refundMap[item.orderId] = {
                    refundId: item.refundId,
                    refundStatus: item.refundStatus,
                    transactionId: item.transactionId,
                    paymentMethod: item.paymentMethod,
                    price: item.price
                };
            });

            setRefundHistory(refundMap);



        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchRefundHistory();
    }, []);


    const handleSaveRefund = async () => {
        try {
            showLoader();

            if (selectedRefund.refundStatus === "REFUNDED") {
                alert("This refund has already been processed.");
                return;
            }

            if (selectedRefund.paymentMethod === "Online_Payment") {

                await refundApi.processOnlineRefund(
                    selectedRefund.transactionId
                );

            } // ─── For Wallet Payment ──────────────────────────────────
            else if (selectedRefund.paymentMethod === "Maamaas_Wallet") {
                const userId = selectedRefund.userId || selectedRefund.customerId;
                const amount = selectedRefund.grandTotal || selectedRefund.totalAmount || selectedRefund.price || 0;

                if (!userId) {
                    alert("User ID not found. Cannot process wallet refund.");
                    return;
                }

                if (amount <= 0) {
                    alert("Invalid amount for refund.");
                    return;
                }

                await refundApi.processWalletRefund(
                    userId,
                    amount,
                    selectedRefund.orderId,
                    `Refunded amount ₹${amount} for order ${selectedRefund.orderId}`
                );
            }

            await refundApi.updateRefundStatus(
                selectedRefund.refundId,
                "REFUNDED"
            );

            await fetchRefundHistory();

            alert("Refund processed successfully.");

            closePopup();

        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Refund Failed");
        } finally {
            hideLoader();
        }
    };

    const handleApprove = async (orderId) => {
        try {
            const refund = await refundApi.getRefundByOrderId(orderId);



            setSelectedRefund(
                Array.isArray(refund) ? refund[0] : refund
            );

            setIsPopupOpen(true);

        } catch (err) {
            console.error(err);

            if (err.response?.status === 404) {
                alert("No refund history found for this order.");
            } else {
                alert("Unable to fetch refund details.");
            }
        }
    };


    const openRefundPopup = (order) => {

        const refund = refundHistory[order.orderId];

        if (!refund) {
            alert("Refund details not found.");
            return;
        }

        setSelectedRefund({
            ...order,
            refundId: refund.refundId,
            refundStatus: refund.refundStatus,
            transactionId: refund.transactionId,
            paymentMethod: refund.paymentMethod
        });

        setIsPopupOpen(true);
    };


    const fetchAllOrders = async (currentPage = 0) => {
        setLoading(true);
        showLoader();

        try {
            const token = localStorage.getItem("authToken");
            const response = await getAllOrders(
                currentPage,
                pageSize,
                token,
                fromDate,
                toDate
            );

            const orders = Array.isArray(response) ? response : response.content || [];
            setAllOrders(orders);

            const filtered = applyFiltersToData(orders, searchTerm, searchType);
            setFilteredOrders(filtered);
            setDisplayedOrders(filtered);

            setTotalOrders(response.totalElements || response.totalCount || orders.length);
        } catch (err) {
            console.error("Error fetching orders:", err);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const applyFiltersToData = (data, search, type) => {
        // If we have a searched order from API, return it directly
        if (searchedOrder && type === "orderId" && search.trim()) {
            return [searchedOrder];
        }

        return data.filter((item) => {
            // Date filters
            if (fromDate || toDate) {
                const orderDate = new Date(item.orderDateAndTime).toISOString().split("T")[0];
                if (fromDate && orderDate < fromDate) return false;
                if (toDate && orderDate > toDate) return false;
            }

            // Search filters (non-orderId searches)
            if (search.trim() && type !== "orderId") {
                const searchLower = search.toLowerCase().trim();
                switch (type) {
                    case "vendorId":
                        return item.vendorId?.toString().includes(searchLower);
                    case "name":
                        return item.userName?.toLowerCase()?.includes(searchLower);
                    case "companyName":
                        return item.userCompany?.toLowerCase()?.includes(searchLower);
                    case "category":
                        return item.appType?.toLowerCase()?.includes(searchLower);
                    default:
                        return true;
                }
            }
            return true;
        });
    };

    useEffect(() => {
        const filtered = applyFiltersToData(allOrders, searchTerm, searchType);
        setFilteredOrders(filtered);
        setDisplayedOrders(filtered);
    }, [searchTerm, searchType, allOrders, fromDate, toDate]);

    useEffect(() => {
        fetchAllOrders(page);
    }, [page]);

    const handleFilterChange = () => {
        setPage(0);
        fetchAllOrders(0);
    };

    const handleExport = () => {
        if (filteredOrders.length === 0) {
            alert("No data available for export.");
            return;
        }

        try {
            const headersCSV = [
                "S.NO", "Order ID", "Vendor ID", "Company Name", "Date", "Time",
                "Category", "Type", "Name", "Payment", "Status", "Amount",
                "Feedback", "Ratings", "Refund Status"
            ];

            const csvRows = filteredOrders.map((item, index) => [
                index + 1,
                item.orderId || "",
                item.vendorId || "",
                item.userCompany || "-",
                new Date(item.orderDateAndTime).toLocaleDateString(),
                new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                item.appType || "Food",
                item.orderType?.replace(/[_-]/g, "") || "-",
                item.userName || "-",
                item.paymentMethod?.replace(/[_-]/g, "") || "-",
                item.status || "-",
                Math.round(item.grandTotal) || "-",
                item.feedback || "-",
                item.ratings || "-",
                refundStatus[item.orderId] || "Pending"
            ]);

            const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");
            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `orders_${new Date().toISOString().split('T')[0]}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Export error:", err);
            alert("Failed to export data. Please try again.");
        }
    };

    const handleViewChange = (type) => {
        setViewType(type);
        setPage(0);
        setSelectedDate("");
        setSearchTerm("");
        setSearchType("orderId");
        if (type === "orders") {
            if (allOrders.length > 0) {
                setFilteredOrders(allOrders);
                setTotalOrders(allOrders.length);
                setDisplayedOrders(allOrders.slice(0, pageSize));
            } else {
                fetchAllOrders(true);
            }
        }
    };



    const handleRefundConfirm = () => {
        if (selectedOrder) {
            setRefundStatus(prev => ({
                ...prev,
                [selectedOrder.orderId]: "Refunded"
            }));
            setShowRefundPopup(false);

        }
    };

    const goNext = () => setPage(prev => prev + 1);
    const goPrevious = () => { if (page > 0) setPage(prev => prev - 1); };

    const getVisiblePages = () => {
        const totalPages = Math.ceil(totalOrders / pageSize);
        if (totalPages <= 3) return Array.from({ length: totalPages }, (_, i) => i);
        if (page === 0) return [0, 1, 2];
        if (page === totalPages - 1) return [page - 2, page - 1, page];
        return [page - 1, page, page + 1];
    };

    const getStatusStyle = (status) => {
        if (!status) return styles.statusDefault;
        const lower = status.toLowerCase();
        if (lower === 'completed' || lower === 'delivered') return styles.statusCompleted;
        if (lower === 'cancelled' || lower === 'canceled') return styles.statusCancelled;
        if (lower === 'pending' || lower === 'processing') return styles.statusPending;
        return styles.statusDefault;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const d = new Date(dateString);
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    };

    const formatTime = (dateString) => {
        if (!dateString) return "-";
        const d = new Date(new Date(dateString).getTime() + (5.5 * 60 * 60 * 1000));
        return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    };

    // Refund Popup Component
    const RefundPopup = () => {
        if (!showRefundPopup || !selectedOrder) return null;

        return (
            <div className="refund-popup-overlay" onClick={() => setShowRefundPopup(false)}>
                <div className="refund-popup-content" onClick={(e) => e.stopPropagation()}>
                    <div className="refund-popup-header">
                        <h3>🔄 Refund Confirmation</h3>
                        <button
                            className="refund-popup-close"
                            onClick={() => setShowRefundPopup(false)}
                        >
                            ×
                        </button>
                    </div>

                    <div className="refund-popup-body">
                        <div className="refund-info-item">
                            <span className="refund-label">Order ID</span>
                            <span className="refund-value">{selectedOrder.orderId}</span>
                        </div>
                        <div className="refund-info-item">
                            <span className="refund-label">User Name</span>
                            <span className="refund-value">{selectedOrder.userName || "-"}</span>
                        </div>
                        <div className="refund-info-item">
                            <span className="refund-label">Amount</span>
                            <span className="refund-value">₹{Math.round(selectedOrder.grandTotal) || "-"}</span>
                        </div>
                        <div className="refund-info-item">
                            <span className="refund-label">Cancelled At</span>
                            <span className="refund-value">{formatDate(selectedOrder.orderDateAndTime)} {formatTime(selectedOrder.orderDateAndTime)}</span>
                        </div>
                        <div className="refund-info-item">
                            <span className="refund-label">Payment Method</span>
                            <span className="refund-value">{selectedOrder.paymentMethod?.replace(/[_-]/g, "") || "-"}</span>
                        </div>
                    </div>

                    <div className="refund-popup-footer">
                        <button
                            className="refund-popup-cancel"
                            onClick={() => setShowRefundPopup(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="refund-popup-confirm"
                            onClick={handleRefundConfirm}
                        >
                            Confirm Refund
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // Calculate stats
    const totalRevenue = allOrders.reduce((sum, item) => sum + (item.grandTotal || 0), 0);
    const completedCount = allOrders.filter(item => item.status?.toLowerCase() === 'completed' || item.status?.toLowerCase() === 'delivered').length;
    const pendingCount = allOrders.filter(item => item.status?.toLowerCase() === 'pending' || item.status?.toLowerCase() === 'processing').length;
    const cancelledCount = allOrders.filter(item => item.status?.toLowerCase() === 'cancelled' || item.status?.toLowerCase() === 'canceled').length;

    return (
        <div style={styles.container}>
            {viewType === "orders" ? (
                <>


                    {/* Filters */}
                    <div style={styles.filtersContainer}>
                        <div style={styles.searchGroup}>
                            <select
                                value={searchType}
                                onChange={(e) => {
                                    const newType = e.target.value;
                                    setSearchType(newType);
                                    setSearchTerm("");
                                    setSearchedOrder(null);

                                    // Reset to show all orders when switching search type
                                    setFilteredOrders(allOrders);
                                    setDisplayedOrders(allOrders);
                                }}
                                style={styles.select}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchTerm}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSearchTerm(value);

                                    // If searching by orderId, use API
                                    if (searchType === "orderId") {
                                        handleSearch(value);
                                    } else {
                                        // For other search types, use frontend filter
                                        clearTimeout(window.searchTimeout);
                                        window.searchTimeout = setTimeout(() => {
                                            const filtered = applyFiltersToData(allOrders, value, searchType);
                                            setFilteredOrders(filtered);
                                            setDisplayedOrders(filtered);
                                        }, 300);
                                    }
                                }}
                                style={{
                                    ...styles.input,
                                    borderColor: searchTerm ? 'rgb(230 109 51)' : '#e2e8f0'
                                }}
                            />
                        </div>

                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            style={styles.dateInput}
                        />

                        <span style={{ color: '#718096', fontSize: '12px' }}>to</span>

                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            style={styles.dateInput}
                        />

                        <button
                            onClick={handleFilterChange}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            Apply
                        </button>

                        <button
                            onClick={() => {
                                setSearchTerm("");
                                setSearchType("orderId");
                                setFromDate("");
                                setToDate("");
                                setPage(0);
                                fetchAllOrders(0);
                            }}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>

                        <button
                            onClick={handleExport}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Export /> Export
                        </button>
                    </div>

                    {/* Table */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th style={styles.th}>Order ID</th>
                                    <th style={styles.th}>Vendor ID</th>
                                    <th style={styles.th}>Company</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Time</th>
                                    <th style={styles.th}>Category</th>
                                    <th style={styles.th}>Type</th>
                                    <th style={styles.th}>Name</th>
                                    <th style={styles.th}>Payment</th>
                                    <th style={styles.th}>Status</th>
                                    <th style={styles.th}>Amount</th>
                                    <th style={styles.th}>Feedback</th>
                                    <th style={styles.th}>Ratings</th>
                                    <th style={styles.th}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && allOrders.length === 0 ? (
                                    <tr>
                                        <td colSpan="14" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <div style={styles.emptyStateText}>Loading orders...</div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : displayedOrders.length > 0 ? (
                                    displayedOrders.map((item, index) => {
                                        const refund = refundHistory[item.orderId];
                                        return (
                                            <tr
                                                key={`${item.orderId}_${index}`}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    transition: 'background 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                            >
                                                <td style={{ ...styles.td, fontWeight: '500' }}>{item.orderId}</td>
                                                <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{item.vendorId}</td>
                                                <td style={styles.td}>{item.userCompany || "-"}</td>
                                                <td style={styles.td}>{formatDate(item.orderDateAndTime)}</td>
                                                <td style={styles.td}>{formatTime(item.orderDateAndTime)}</td>
                                                <td style={styles.td}>
                                                    <span style={styles.verticalBadge}>
                                                        {item.appType || "Food"}
                                                    </span>
                                                </td>
                                                <td style={styles.td}>{item.orderType?.replace(/[_-]/g, "") || "-"}</td>
                                                <td style={{ ...styles.td, fontWeight: '500' }}>{item.userName || "-"}</td>
                                                <td style={styles.td}>
                                                    {item.paymentMethod?.toLowerCase().includes("wallet") ? (
                                                        <span style={{
                                                            color: '#28a745',
                                                            fontWeight: 'bold',
                                                            background: '#e6f9ed',
                                                            padding: '2px 10px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px'
                                                        }}>
                                                            Wallet
                                                        </span>
                                                    ) : item.paymentMethod?.toLowerCase().includes("online") ? (
                                                        <span style={{
                                                            color: '#2563eb',
                                                            fontWeight: 'bold',
                                                            background: '#dbeafe',
                                                            padding: '2px 10px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px'
                                                        }}>
                                                            Online
                                                        </span>
                                                    ) : (
                                                        <span style={{
                                                            color: '#256a5b',
                                                            fontWeight: 'bold',
                                                            background: '#dbeafe',
                                                            padding: '2px 10px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px'
                                                        }}>{item.paymentMethod?.replace(/[_-]/g, "") || "-"}</span>
                                                    )}
                                                </td>
                                                <td style={styles.td}>
                                                    <span style={{
                                                        ...styles.statusBadge,
                                                        ...getStatusStyle(item.status)
                                                    }}>
                                                        {item.status || "-"}
                                                    </span>
                                                </td>
                                                <td style={{ ...styles.td, fontWeight: '600', color: '#0b5e42' }}>
                                                    ₹{(item.grandTotal) || "-"}
                                                </td>
                                                <td style={styles.td}>{item.feedback || "-"}</td>
                                                <td style={styles.td}>
                                                    {[1, 2, 3, 4, 5].map(star => (
                                                        <span key={star} style={{ color: item.ratings >= star ? '#FFD700' : '#e2e8f0' }}>
                                                            ★
                                                        </span>
                                                    ))}
                                                </td>
                                                <td style={styles.td}>
                                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                        {/* View Button */}
                                                        <button
                                                            onClick={() => handleViewOrder(item)}
                                                            style={{
                                                                padding: '4px 10px',
                                                                borderRadius: '6px',
                                                                border: 'none',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                cursor: 'pointer',
                                                                background: '#2563eb',
                                                                color: 'white',
                                                                transition: 'all 0.2s ease',
                                                                minWidth: '40px'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.background = '#1d4ed8'}
                                                            onMouseLeave={(e) => e.currentTarget.style.background = '#2563eb'}
                                                            title="View Order Details"
                                                        >
                                                            < FaEye />
                                                        </button>

                                                        {/* Refund Button - existing */}
                                                        {refund?.refundStatus === "PENDING" ? (
                                                            <button
                                                                onClick={() => openRefundPopup(item)}
                                                                style={{
                                                                    ...styles.refundButton,
                                                                    ...styles.refundActive
                                                                }}
                                                            >
                                                                Refund
                                                            </button>
                                                        ) : refund?.refundStatus === "REFUNDED" ? (
                                                            <span style={{ color: "#28a745", fontWeight: "bold" }}>
                                                                ✓ Refunded
                                                            </span>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="14" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <div style={{ fontSize: '48px', opacity: 0.5 }}>📋</div>
                                                <div style={styles.emptyStateText}>
                                                    {allOrders.length === 0 ? 'No orders found' : 'No orders match your filters'}
                                                </div>
                                                <div style={styles.emptyStateSubtext}>
                                                    {allOrders.length === 0
                                                        ? 'Orders will appear here once they are placed'
                                                        : 'Try adjusting your filters to see more results'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {totalOrders > 0 && (
                        <div style={styles.paginationContainer}>
                            <button
                                disabled={page === 0}
                                onClick={goPrevious}
                                style={{
                                    ...styles.pageButton,
                                    ...(page === 0 ? styles.pageButtonDisabled : {})
                                }}
                            >
                                <Icons.Previous /> Prev
                            </button>

                            {getVisiblePages().map((p) => (
                                <button
                                    key={p}
                                    onClick={() => setPage(p)}
                                    style={{
                                        ...styles.pageButton,
                                        ...(page === p ? styles.pageButtonActive : {})
                                    }}
                                >
                                    {p + 1}
                                </button>
                            ))}

                            <button
                                disabled={(page + 1) * pageSize >= totalOrders}
                                onClick={goNext}
                                style={{
                                    ...styles.pageButton,
                                    ...((page + 1) * pageSize >= totalOrders ? styles.pageButtonDisabled : {})
                                }}
                            >
                                Next <Icons.Next />
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <Fooduserwalletorders />
            )}

            {isPopupOpen && selectedRefund && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.55)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        padding: "20px",
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            width: "700px",
                            maxWidth: "95%",
                            maxHeight: "85vh",
                            overflowY: "auto",
                            borderRadius: "12px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                            padding: "25px",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #eee",
                                paddingBottom: "12px",
                                marginBottom: "20px",
                            }}
                        >
                            <h3
                                style={{
                                    margin: 0,
                                    color: "#185FA5",
                                    fontSize: "22px",
                                    fontWeight: "600",
                                }}
                            >
                                Refund Details
                            </h3>

                            <button
                                onClick={closePopup}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    color: "#666",
                                }}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Body */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "18px",
                            }}
                        >
                            <div>
                                <label style={{ fontWeight: 600 }}>Refund ID</label>
                                <input
                                    value={selectedRefund.refundId || "-"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Order ID</label>
                                <input
                                    value={selectedRefund.orderId || "-"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>User Name</label>
                                <input
                                    value={selectedRefund.userName || "-"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Amount</label>
                                <input
                                    value={`₹${selectedRefund.grandTotal || 0}`}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Cancelled At</label>
                                <input
                                    value={refundDateFormatter.formatDateTimeForDisplay(
                                        selectedRefund.cancelledAt
                                    )}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Transaction ID</label>
                                <input
                                    value={selectedRefund.transactionId || "-"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Payment Method</label>
                                <input
                                    value={selectedRefund.paymentMethod || "-"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: 600 }}>Status</label>
                                <input
                                    value={selectedRefund.status || "Cancelled"}
                                    readOnly
                                    style={refundUIConstants.tableStyles.input}
                                />
                            </div>

                            <div style={{ gridColumn: "1 / span 2" }}>
                                <label style={{ fontWeight: 600 }}>Cancel Reason</label>
                                <textarea
                                    value={selectedRefund.cancelReason || "-"}
                                    readOnly
                                    rows={3}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        borderRadius: "6px",
                                        resize: "none",
                                        fontSize: "14px",
                                    }}
                                />
                            </div>
                        </div>



                        {/* Footer */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "12px",
                                marginTop: "25px",
                                borderTop: "1px solid #eee",
                                paddingTop: "20px",
                            }}
                        >
                            <button
                                onClick={closePopup}
                                style={{
                                    padding: "10px 22px",
                                    border: "none",
                                    borderRadius: "6px",
                                    background: "#dc3545",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                }}
                            >
                                Close
                            </button>

                            <button
                                onClick={handleSaveRefund}
                                style={{
                                    padding: "10px 22px",
                                    border: "none",
                                    borderRadius: "6px",
                                    background: "#28a745",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                }}
                            >
                                Refund Now
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Styles for Refund Popup */}
            <style jsx>{`
                .refund-popup-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                    animation: fadeIn 0.3s ease;
                    padding: 20px;
                }

                .refund-popup-content {
                    background: #ffffff;
                    border-radius: 16px;
                    max-width: 500px;
                    width: 100%;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
                    animation: slideUp 0.3s ease;
                    max-height: 90vh;
                    overflow-y: auto;
                }

                .refund-popup-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px 24px 16px 24px;
                    border-bottom: 2px solid #f0f0f0;
                }

                .refund-popup-header h3 {
                    margin: 0;
                    color: #2d3748;
                    font-size: 20px;
                    font-weight: 600;
                }

                .refund-popup-close {
                    background: none;
                    border: none;
                    font-size: 28px;
                    cursor: pointer;
                    color: #999;
                    padding: 0 8px;
                    transition: color 0.3s ease;
                }

                .refund-popup-close:hover {
                    color: #333;
                }

                .refund-popup-body {
                    padding: 20px 24px;
                }

                .refund-info-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 0;
                    border-bottom: 1px solid #f5f5f5;
                }

                .refund-info-item:last-child {
                    border-bottom: none;
                }

                .refund-label {
                    color: #666;
                    font-weight: 500;
                    font-size: 14px;
                }

                .refund-value {
                    color: #333;
                    font-weight: 600;
                    font-size: 14px;
                    text-align: right;
                    word-break: break-word;
                    max-width: 60%;
                }

                .refund-popup-footer {
                    display: flex;
                    gap: 12px;
                    padding: 16px 24px 24px 24px;
                    border-top: 2px solid #f0f0f0;
                    justify-content: flex-end;
                    flex-wrap: wrap;
                }

                .refund-popup-cancel {
                    padding: 10px 24px;
                    background: #e2e8f0;
                    border: none;
                    border-radius: 8px;
                    cursor: pointer;
                    font-weight: 500;
                    color: #4a5568;
                    transition: all 0.3s ease;
                    min-width: 100px;
                }

                .refund-popup-cancel:hover {
                    background: #cbd5e0;
                }

                .refund-popup-confirm {
                    padding: 10px 24px;
                    background: #48bb78;
                    border: none;
                    border-radius: 8px;
                    cursor: pointer;
                    font-weight: 500;
                    color: white;
                    transition: all 0.3s ease;
                    min-width: 100px;
                }

                .refund-popup-confirm:hover {
                    background: #38a169;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px) scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }

                .vertical-badge {
                    font-size: 11px;
                    background: #edf2f7;
                    padding: 2px 8px;
                    border-radius: 4px;
                    color: #4a5568;
                    display: inline-block;
                }

                @media (max-width: 768px) {
                    .refund-popup-content {
                        max-width: 95%;
                        margin: 10px;
                    }

                    .refund-popup-header {
                        padding: 16px 18px 12px 18px;
                    }

                    .refund-popup-header h3 {
                        font-size: 17px;
                    }

                    .refund-popup-body {
                        padding: 16px 18px;
                    }

                    .refund-info-item {
                        flex-direction: column;
                        gap: 4px;
                        padding: 8px 0;
                    }

                    .refund-value {
                        text-align: left;
                        max-width: 100%;
                    }

                    .refund-popup-footer {
                        flex-direction: column-reverse;
                        padding: 12px 18px 18px 18px;
                    }

                    .refund-popup-cancel,
                    .refund-popup-confirm {
                        width: 100%;
                        padding: 12px;
                        min-width: unset;
                    }
                }

                @media (max-width: 480px) {
                    .refund-popup-content {
                        max-width: 100%;
                        border-radius: 8px;
                    }

                    .refund-popup-header h3 {
                        font-size: 15px;
                    }

                    .refund-popup-body {
                        padding: 12px 14px;
                    }

                    .refund-label,
                    .refund-value {
                        font-size: 13px;
                    }

                    .refund-popup-footer {
                        padding: 10px 14px 14px 14px;
                    }
                }
            `}</style>
            {/* Order Details Modal */}
            {showOrderDetails && selectedOrderForView && (
                <OrderDetails
                    order={selectedOrderForView}
                    onClose={() => setShowOrderDetails(false)}
                />
            )}

        </div>
    );
};

export default Fooduserorders;